import { ConfidenceLogoHorizontal } from './ConfidenceLogoHorizontal';

import styles from './Branding.module.css';

export const Branding = () => (
  <div className={styles.root}>
    <ConfidenceLogoHorizontal />
  </div>
);
